import "@arco-design/web-react/es/Dropdown/style";
import _Dropdown from "@arco-design/web-react/es/Dropdown";
import "@arco-design/web-react/es/Avatar/style";
import _Avatar from "@arco-design/web-react/es/Avatar";
import _IconLoading from "@arco-design/web-react/icon/react-icon/IconLoading";
import _IconPoweroff from "@arco-design/web-react/icon/react-icon/IconPoweroff";
import "@arco-design/web-react/es/Divider/style";
import _Divider from "@arco-design/web-react/es/Divider";
import "@arco-design/web-react/es/Menu/style";
import _Menu from "@arco-design/web-react/es/Menu";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import _IconSettings from "@arco-design/web-react/icon/react-icon/IconSettings";
import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import React, { useContext, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { GlobalContext } from '@/context';
import useLocale from '@/utils/useLocale';
import Logo from '@/assets/logo2.svg';
import Settings from '../Settings';
import styles from './style/index.module.less';
import useStorage from '@/utils/useStorage';
import { generatePermission } from '@/routes';
import xsAPI from '@/xsAPI';

function Navbar({
  show
}) {
  const t = useLocale();
  const {
    userInfo,
    userLoading
  } = useSelector(state => state);
  const dispatch = useDispatch();
  const [_, setUserStatus] = useStorage('userStatus');
  const [role, setRole] = useStorage('userRole', 'admin');
  const {
    setLang,
    lang,
    theme,
    setTheme
  } = useContext(GlobalContext);

  function logout() {
    setUserStatus('logout');
    xsAPI.post('/auth/v1/manager/loginOut', {
      token: localStorage.getItem('access_token')
    }).then(() => {
      localStorage.removeItem('access_token');
      window.location.href = '/login';
    });
  }

  function onMenuItemClick(key) {
    if (key === 'logout') {
      logout();
    } else {
      _Message.info(`You clicked ${key}`);
    }
  }

  useEffect(() => {
    dispatch({
      type: 'update-userInfo',
      payload: {
        userInfo: { ...userInfo,
          permissions: generatePermission(role)
        }
      }
    });
  }, [role]);

  if (!show) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles['fixed-settings']
    }, /*#__PURE__*/React.createElement(Settings, {
      trigger: /*#__PURE__*/React.createElement(_Button, {
        icon: /*#__PURE__*/React.createElement(_IconSettings, null),
        type: "primary",
        size: "large"
      })
    }));
  }

  const handleChangeRole = () => {
    const newRole = role === 'admin' ? 'user' : 'admin';
    setRole(newRole);
  };

  const droplist = /*#__PURE__*/React.createElement(_Menu, {
    onClickMenuItem: onMenuItemClick
  }, /*#__PURE__*/React.createElement(_Menu.Item, {
    key: "setting"
  }, /*#__PURE__*/React.createElement(_IconSettings, {
    className: styles['dropdown-icon']
  }), t['menu.user.setting']), /*#__PURE__*/React.createElement(_Divider, {
    style: {
      margin: '4px 0'
    }
  }), /*#__PURE__*/React.createElement(_Menu.Item, {
    key: "logout"
  }, /*#__PURE__*/React.createElement(_IconPoweroff, {
    className: styles['dropdown-icon']
  }), t['navbar.logout']));
  return /*#__PURE__*/React.createElement("div", {
    className: styles.navbar
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.logo
  }, /*#__PURE__*/React.createElement(Logo, {
    height: 24
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['logo-name']
  }, "\u6653\u6570\u667A\u80FD \xB7 \u7BA1\u7406\u540E\u53F0"))), /*#__PURE__*/React.createElement("ul", {
    className: styles.right
  }, userInfo && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(_Dropdown, {
    droplist: droplist,
    position: "br",
    disabled: userLoading
  }, /*#__PURE__*/React.createElement(_Avatar, {
    size: 32,
    style: {
      cursor: 'pointer'
    }
  }, userLoading ? /*#__PURE__*/React.createElement(_IconLoading, null) : /*#__PURE__*/React.createElement("img", {
    alt: "avatar",
    width: 32,
    src: userInfo.headerImg
  }))))));
}

export default Navbar;